export const SUCCESS = 'success';
export const INFO = 'info';
export const ERROR = 'error';